"use client"
import { useEffect, useState } from 'react'
import { configured, consent, setConsent } from './client'
/** Consent is shared across production subdomains; no tracking starts before acceptance. */
export function AnalyticsConsent() {
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setOpen(configured() && consent() === '')
    window.dispatchEvent(new Event('smkt:analytics-ready'))
    const reopen = () => setOpen(configured())
    window.addEventListener('smkt:analytics-preferences', reopen)
    return () => window.removeEventListener('smkt:analytics-preferences', reopen)
  }, [])
  if (!configured() || !open) return null
  const button = { border: '1px solid #004E99', padding: '7px 12px', background: '#fff', color: '#004E99', cursor: 'pointer', font: 'inherit' }
  return <aside data-analytics-ignore style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 1000, maxWidth: 390, font: '13px/1.5 system-ui', color: '#000D1A' }} aria-label="Analytics preferences">
    <div style={{ padding: 16, background: '#F5FAFF', border: '1px solid #8AC6FF', boxShadow: '0 3px 20px #0002' }}>
      <strong>Help improve SecondaryMKT</strong><p style={{ margin: '8px 0' }}>Allow analytics to understand visits and product use across our sites. We exclude form contents and loan details.</p>
      <div style={{ display: 'flex', gap: 8 }}><button style={button} onClick={() => { setConsent(true); setOpen(false) }}>Allow analytics</button><button style={button} onClick={() => { setConsent(false); setOpen(false) }}>Decline</button></div>
    </div>
  </aside>
}

/** Reopening is deliberate, from a footer or account menu, never a floating control. */
export function openAnalyticsPreferences() {
  window.dispatchEvent(new Event('smkt:analytics-preferences'))
}
export function PrivacyChoices({ className }: { className?: string }) {
  const [enabled, setEnabled] = useState(false)
  useEffect(() => {
    const sync = () => setEnabled(configured())
    sync()
    window.addEventListener('smkt:analytics-ready', sync)
    return () => window.removeEventListener('smkt:analytics-ready', sync)
  }, [])
  return enabled ? <button type="button" data-analytics-ignore className={className} onClick={openAnalyticsPreferences}>Privacy choices</button> : null
}
